import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { getCsrfToken, MetaTags, MetaTagsService } from '@mode/shared/util-js';
import {
  ImportNotebookSocketSuccessPayload,
  NotebookImportPayload,
  NotebookImportResponse,
  NotebookResource,
  SessionResource,
} from '@mode/notebooks/contract';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { SocketService } from '@mode/shared/data-access-socket';
@Injectable({
  providedIn: 'root',
})
export class NotebookClientService {
  constructor(
    private http: HttpClient,
    private metaTags: MetaTagsService,
    private socketService: SocketService
  ) {}

  createNotebook(reportToken: string): Observable<NotebookResource> {
    const orgId = this.metaTags.getTag(MetaTags.OwnerUsername);
    const apiUrl = `api/${orgId}/notebooks`;

    const embedParams = [
      'perspective_python_sessions',
      'python_cells',
      'new_python_cell',
      'new_python_session',
      'new_python_cell_batch_run',
      'last_report_run',
      'report',
    ];

    const params = embedParams.reduce((acc, key) => acc.set(`embed[${key}]`, '1'), new HttpParams());

    const body = {
      report_token: reportToken,
      python_notebook: { doc_cells: true },
    };

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': getCsrfToken(window.document) ?? '',
    });

    return this.http.post<NotebookResource>(apiUrl, body, { params, headers });
  }

  loadReportRun(org: string, reportToken: string, notebookToken: string, sessionToken: string, runToken: string) {
    const url = `/api/${org}/reports/${reportToken}/notebooks/${notebookToken}/sessions/${sessionToken}/load_report_run`;
    const body = {
      report_run: { token: runToken },
    };

    return this.http.post<SessionResource>(url, body);
  }

  importNotebook(filePayload: NotebookImportPayload): Observable<NotebookImportResponse> {
    const apiUrl = `api/${filePayload.orgId}/notebooks/import`;

    const formData = new FormData();
    formData.append('file', filePayload.file);
    filePayload.reportToken && formData.append('report_token', filePayload.reportToken);

    // const embedParams = [
    //   'perspective_python_sessions',
    //   'python_cells',
    //   'new_python_cell',
    //   'new_python_session',
    //   'new_python_cell_batch_run',
    //   'last_report_run',
    //   'report',
    // ];

    // const params = embedParams.reduce((acc, key) => acc.set(`embed[${key}]`, '1'), new HttpParams());
    //TODO: Add embed params once we have entry point ready or will remove this

    const headers = new HttpHeaders({
      'X-CSRF-TOKEN': getCsrfToken(window.document) ?? '',
    });
    return this.http.post<NotebookImportResponse>(apiUrl, formData, { headers });
  }

  cancelRun(orgToken: string, reportToken: string, notebookToken: string, sessionToken: string) {
    const url = `/api/${orgToken}/reports/${reportToken}/notebooks/${notebookToken}/sessions/${sessionToken}/cancel`;
    return this.http.post<void>(url, {});
  }

  public connectToImportNotebookSocket(pusherChannelName: string) {
    return this.socketService.connect<ImportNotebookSocketSuccessPayload>(pusherChannelName);
  }
}
